import { useSelector } from 'react-redux';
import { IS_BLOCKED } from 'reactApp/appHelpers/configHelpers';
import { enabledPublicDownloadLimits } from 'reactApp/appHelpers/featuresHelpers/features/publicDownloadLimits';
import { AllDocumentsDomainMeta } from 'reactApp/modules/allDocuments/allDocuments.constants';
import { EAllDocumentsType } from 'reactApp/modules/allDocuments/allDocuments.types';
import { isDefaultRootContent } from 'reactApp/modules/home/home.selectors';
import { getFirstPublicWithDownloadLeftZero } from 'reactApp/modules/public/public.selectors';
import { selectStatusPage } from 'reactApp/modules/router/router.selectors';
import { SelectionsSelectors } from 'reactApp/modules/selections/selections.selectors';
import { isUploaderVisible } from 'reactApp/modules/uploadList/uploadList.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import type { RootState } from 'reactApp/store';

const tabs = [
    {
        name: AllDocumentsDomainMeta.document.name,
        value: EAllDocumentsType.document,
    },
    {
        name: AllDocumentsDomainMeta.spreadsheet.name,
        value: EAllDocumentsType.spreadsheet,
    },
    {
        name: AllDocumentsDomainMeta.presentation.name,
        value: EAllDocumentsType.presentation,
    },
    {
        name: AllDocumentsDomainMeta.pdf.name,
        value: EAllDocumentsType.pdf,
    },
];

export const useGetPageData = () => {
    const selectedIds = useSelector(SelectionsSelectors.getSelectedIdxs);
    const isDefaultContent = useSelector(isDefaultRootContent);
    const statusPage = useSelector(selectStatusPage);
    const showUploader = useSelector(isUploaderVisible);
    const showActionsBar = selectedIds.length > 0;
    const showUploadArea = !showUploader && !showActionsBar;
    const isFrozen = useSelector(UserSelectors.isFrozen);
    const isPaidUser = useSelector(UserSelectors.isPaidUser);

    const disableContent = IS_BLOCKED || isFrozen;

    // tempexp_17847-start
    const firstPublicWithDownloadLeftZero = useSelector((state: RootState) => getFirstPublicWithDownloadLeftZero(state));
    const valuePublicLimits = firstPublicWithDownloadLeftZero && Object.values(firstPublicWithDownloadLeftZero)[0];
    const leftDownloads = valuePublicLimits && valuePublicLimits.left;
    const totalDownloads = valuePublicLimits && valuePublicLimits.total;
    const showDownloadLimitsInformer = enabledPublicDownloadLimits && !isPaidUser && leftDownloads === 0;
    // tempexp_17847-end

    return {
        isDefaultContent,
        statusPage,
        showUploadArea,
        disableContent,
        totalDownloads,
        showDownloadLimitsInformer,
        showUploader,
        showActionsBar,
        tabs,
    };
};
